module.exports = __webpack_public_path__ + "img/step_img_05.0bec3b7c.webp";